import { format } from "date-fns";
import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const ApplyDateTimePicker = ({
  value,
  onChange,
  minDate = new Date(),
  disabled = false,
  id,
  onBlur,
  maxDate
}) => {
  const [tempDate, setTempDate] = useState(value ? new Date(value) : null);
  const [open, setOpen] = useState(false);

  return (
    <div className="relative w-full">
      <i className="fa fa-clock absolute left-3 top-1/2 transform -translate-y-1/2 text-[#ff702b]"></i>
      {/* Input */}
      <input
        type="text"
        readOnly
        disabled={disabled}
        id={id}
        onBlur={onBlur}
        value={
          value
            ? format(new Date(value), "dd-MM-yyyy hh:mm aa")
          : ""
       }
        onClick={() => !disabled && setOpen(true)}
        className="form-control w-full !border-[#DDDDDD] !rounded-[5px] pl-10"
        placeholder="Select Date & Time"
      />

      {/* Picker */}
      {open && (
        <div className="absolute z-50 bg-white shadow-lg p-3 rounded-md mt-1">
          <DatePicker
            selected={tempDate}
            onChange={(date) => setTempDate(date)}
            showTimeSelect
            minDate={minDate}
            maxDate={maxDate}
            dateFormat="dd-MM-yyyy hh:mm aa"
            timeFormat="hh:mm aa"
            timeIntervals={15}
            inline
          />

          {/* Buttons */}
          <div className="flex justify-end gap-2 mt-2">
            <button
              type="button"
              className="px-3 py-1 text-sm border rounded"
              onClick={() => {
                setTempDate(value ? new Date(value) : null);
                setOpen(false);
              }}
            >
              Cancel
            </button>

            <button
              type="button"
              className="px-3 py-1 text-sm bg-[#ff702b] text-white rounded"
              onClick={() => {
                if (tempDate) onChange(tempDate);
                setOpen(false);
              }}
            >
              Apply
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ApplyDateTimePicker;
